import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import MessageDisaplay from './message-display';
import messages from './messages';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import style from './style.module.less';

export const DisplayActivityEntry = ({ activityEntry, sellerTimeZone, userDateTimeFormat }) => {
  const { createDateTime, username, message } = activityEntry;
  const filteredMessage = message.replace(/\n/gi, '\n');
  const userDateTime = moment(createDateTime).tz(sellerTimeZone).format(userDateTimeFormat);

  return (
    <div>
      <div className={classNames(style['fulfillment-plan-activity-entry-title'], 'od-canvas-fulfillment-plan-activity-entry-title')}>
        <FontAwesomeIcon className={style['icon-part']} icon={faClock} /> <b>{userDateTime}</b> {' by: '}
        <FontAwesomeIcon className={style['icon-part-scale']} icon={faUser} /> <b>{username || 'System'}</b>
      </div>
      <div className={classNames(style['fulfillment-plan-activity-entry'], 'od-canvas-fulfillment-plan-activity-entry')}>
        {filteredMessage}
      </div>
      <br />
    </div>
  );
};

DisplayActivityEntry.propTypes = {
  activityEntry: PropTypes.shape({
    createDateTime: PropTypes.string,
    username: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  sellerTimeZone: PropTypes.string.isRequired,
  userDateTimeFormat: PropTypes.string.isRequired,
};

export const displayNewActivityEntry = (activityEntry, index, sellerTimeZone, userDateTimeFormat, sellerUsers) => {
  const { timeStampUtc, actorUserId, actorUsername, eventType, attributes } = activityEntry;
  const attributesObject = attributes?.reduce((obj, item) => ({ ...obj, [item.key]: item.value }), {}) || {};
  const getUserName = (users, id) => users?.find((user) => user.userId === id);
  const username = actorUsername || getUserName(sellerUsers, actorUserId)?.username || <FormattedMessage {...messages.system} />;
  attributesObject.sellerTimeZone = sellerTimeZone;
  attributesObject.userDateTimeFormat = userDateTimeFormat;
  const userDateTime = moment(timeStampUtc).tz(sellerTimeZone).format(userDateTimeFormat);
  return (
    <div key={`${eventType}-${index}`}>
      <div className={style['fulfillment-plan-activity-entry-title']}>
        <FormattedMessage
          {...messages.rowHeader}
          values={{
            userDateTime,
            username,
            a: (chunks) => (
              <>
                <FontAwesomeIcon className={style['icon-part']} icon={faClock} />
                <b> {chunks}</b>
              </>
            ),
            b: (chunks) => (
              <>
                <FontAwesomeIcon className={style['icon-part-scale']} icon={faUser} />
                <b> {chunks}</b>
              </>
            ),
          }}
        />
      </div>
      <div className={style['fulfillment-plan-activity-entry']}>
        <MessageDisaplay attributes={attributesObject} event={eventType} />
      </div>
      <br />
    </div>
  );
};
